
import Loader from "./loader";
export default {
  name: "FullScreenLoader",
  props: ["loading"],
  data() {
    return {};
  },

  methods: {}
};
